import * as React from 'react'
import { LayoutApp } from 'components/shared/layouts/LayoutApp'
import { layoutService } from 'services/LayoutService'
import { Meta } from 'components/shared/Meta'
import { Title } from '../shared/ui/Title'
import { PageFrame } from '../../base/components/ui/PageFrame'
import imgIntro from '../../assets/images/intro.png'
import IconPlay from '@material-ui/icons/PlayArrow'
import { ButtonLink } from '../../base/components/ui/ButtonLink'
import styles from './ViewHome.module.scss'

interface Props {
}

export class ViewHome extends React.PureComponent<Props> {
  public componentDidMount() {
    layoutService.setHeaderLarge(false)
    layoutService.setBreadcrumbs([{ label: 'Introduction' }])
  }

  public render() {
    return (
      <LayoutApp>
        <Meta title="Introduction" />
        <PageFrame simple>
          <div className={styles.root}>
            <div className={styles.content}>
              <Title type={'h1'}>Core Dynamics of Infectious Disease</Title>
              <Title type={'h2'}>Simulation model</Title>
              <div className={styles.text}>
                <p>With COVID-19, epidemiologists and modellers have a new found prominance and terms like flattening
                   the curve have entered our language. But the models they use are complex and not accessible to the
                   average person. This model was created to demystify models and their jargon, and to help people
                   understand the impact of interventions such as social distancing and vaccines. Each of these has an
                   impact and the impact is amplified if they work together.</p>
                <p>Use the scenarios to test the how 2 different diseases (measles and influenza) have different
                   impacts on a population.</p>
                <p>Use the sliders to explore your own scenarios. Note how effective the vaccine has to be and how
                   many people need to be vaccinated for a vaccination programme to be effective. Notice not just the
                   number of people infected but how the curve changes as you interact with the sliders.</p>
                <p>While these numbers do not pretend to realistically model these diseases, they do show how various
                   interventions affect the total numbers of people who become infected, when and over what time
                   period.</p>
                <p>Enjoy exploring.</p>
                <div className={styles.buttons}>
                  <ButtonLink variant={'contained'} color={'primary'} to={'/simulation'}>
                    <IconPlay /> View Model
                  </ButtonLink>
                  {/*<Button variant={'contained'} color={'primary'}>*/}
                  {/*  <IconCogs /> Explore Model*/}
                  {/*</Button>*/}
                </div>
              </div>
            </div>
            <div className={styles.introImage} />
          </div>
        </PageFrame>
      </LayoutApp>
    )
  }
}
